import React from 'react';

import styled from 'styled-components';

import CreateEditActionPlansModalItemsList from './CreateEditActionPlansModalItemsList';
import CreateEditActionPlansModalRight from './CreateEditActionPlansModalRight';
import CreateEditActionPlansModalSidebar from './CreateEditActionPlansModalSidebar';
import { OwnerOption, SelectOption } from './CreateEditActionPlansModalTypes';

const CreateModalLayout = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: 330px minmax(0, 1fr);
  min-height: 0;
  height: 100%;
  overflow: hidden;
`;

const SectionHeading = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
  margin-bottom: 15px;
`;

interface Props {
  categoryOptions: SelectOption[];
  itemTypeOptions: SelectOption[];
  ownerOptions: OwnerOption[];
}

const CreateEditActionPlansModalMainContent = ({ categoryOptions, itemTypeOptions, ownerOptions }: Props) => {
  return (
    <CreateModalLayout>
      <CreateEditActionPlansModalSidebar categoryOptions={categoryOptions} ownerOptions={ownerOptions} />

      <CreateEditActionPlansModalRight>
        <SectionHeading>Action Items</SectionHeading>
        <CreateEditActionPlansModalItemsList itemTypeOptions={itemTypeOptions} ownerOptions={ownerOptions} />
      </CreateEditActionPlansModalRight>
    </CreateModalLayout>
  );
};

export default CreateEditActionPlansModalMainContent;
